var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 687,
    height: 418,
    viewBox: "0 0 687 418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341",
    transform: "translate(-978 -490)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    transform: "translate(978 490)",
    fill: "#81000f",
    stroke: "#80000f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 687,
    height: 418,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 686,
    height: 417,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-image",
    "data-name": "Icon awesome-image",
    d: "M79.261,70.1H8.2A8.2,8.2,0,0,1,0,61.9V12.7A8.2,8.2,0,0,1,8.2,4.5H79.261a8.2,8.2,0,0,1,8.2,8.2V61.9A8.2,8.2,0,0,1,79.261,70.1ZM19.132,14.066A9.566,9.566,0,1,0,28.7,23.632,9.566,9.566,0,0,0,19.132,14.066Zm-8.2,45.1h65.6V40.031L61.579,25.081a2.05,2.05,0,0,0-2.9,0L35.531,48.23l-9.483-9.483a2.05,2.05,0,0,0-2.9,0L10.933,50.964Z",
    transform: "translate(1277.698 661.764)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngi);
export default __webpack_public_path__ + "static/media/engi.b477c3e8e424bd3559af67e615979d41.svg";
export { ForwardRef as ReactComponent };